import sales, { salesByNftId } from './sales';

const standaloneNfts = [
  {
    _id: 'demo-nft-11',
    tokenId: '1011',
    title: 'Saffron Mini Satchel',
    description: 'Vibrant mini satchel collected by top buyers on Club Rare.',
    file: '/demo/bag-5.png',
    creator: '0x742d35cc6634c0532925a3b844bc9e7595f0beb0',
    owner: {
      _id: 'demo-user-3',
      name: 'Jordan Cole',
      wallet: '0x3c44cdddb6a900fa2b585dd299e03d12fa4293bc',
      avatar: '/demo/boy.png',
    },
    category: 'fashion',
    createdAt: '2024-10-01T12:00:00.000Z',
  },
  {
    _id: 'demo-nft-12',
    tokenId: '1012',
    title: 'Obsidian Dress Watch',
    description: 'Minimal dress watch with onyx dial and silver indices.',
    file: '/demo/watch-5.png',
    creator: '0x90f79bf6eb2c4f870365e785982e1f101e93b906',
    owner: {
      _id: 'demo-user-5',
      name: 'Ethan Brooks',
      wallet: '0x15d34aaf54267db7d7c367839aaf71a00a2c6a65',
      avatar: '/demo/avatar-2.png',
    },
    category: 'watches',
    createdAt: '2024-09-15T09:30:00.000Z',
  },
];

const saleSummary = (sale) => {
  if (!sale) return undefined;
  const { nft, ...summary } = sale;
  return summary;
};

const nftsFromSales = sales.map((sale) => ({
  ...sale.nft,
  sale: saleSummary(sale),
}));

const nfts = [...nftsFromSales, ...standaloneNfts];

export default nfts;

export const nftsById = nfts.reduce((acc, nft) => {
  acc[nft._id] = nft;
  return acc;
}, {});

export { salesByNftId };
